import { connect } from 'react-redux';

import { AppState } from '../../store/store';

import { PagesStack as Presentation } from './pages-stack.component';

export const PagesStack = connect(
  (state: AppState) => ({
    open: state.layout.navbar,
    selectedPage: state.pages.selected,
    router: state.router.location.hash,
  }),
)(Presentation);
